import useSWR from 'swr';
import type { AirlineSettingsRequest, AirlineSettingsResponse } from '@/app/api/hotel-detail/airline-settings/route';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useInitialParams } from '../InitialParamsProvider';
import { getLoggingInfo } from '../lib/loggingInfo';
import { BASE_PATH } from '../../search/utils/path';
import { fetchWithTracingAndLogging } from '../common/fetchWithTracing';

export function useAirlineSettings() {
  const initialParams = useInitialParams();
  const { searchInfoData, commonData, localization } = usePageWrapperData();
  const key = commonData.sessionId || undefined;

  const payload: AirlineSettingsRequest = {
    businessProfileId: localization.businessProfile,
    pageType: initialParams.pageType,
  };

  return useSWR<AirlineSettingsResponse | null>(
    key,
    async () =>
      fetchWithTracingAndLogging<AirlineSettingsResponse>(
        `${BASE_PATH}/api/hotel-detail/airline-settings`,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
          },
          body: JSON.stringify(payload),
        },
        getLoggingInfo(initialParams.pageType, 'airline-settings', 'useAirlineSettings'),
        searchInfoData.searchTraceParent,
        commonData
      ),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
      dedupingInterval: 1000 * 60 * 30,
    }
  );
}
